const templateString = (tpl, args) => (tpl && typeof tpl === 'string') ? tpl.replace(/{{\s?(\w+)\s?}}/g, (_, v) => args[v] || '') : tpl;
export default templateString;
